import React, { useState } from "react";
import {
  Modal,
  Input,
  //   Select,
  Button,
  Typography,
  DatePicker,
  Loading,
} from "../../../core";
import { Form, Row, Col, Select } from "antd";
import { MixStyle } from "../../../styles";

import styled from "styled-components";
import { useForm } from "antd/lib/form/util";

import { addDispatch } from "../../../helper/utils/api/dispatch";
const { Option } = Select;
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const DispatchModalCompo = ({
  dispatchModal,
  getDispatchesOfCurrentContract,
  contractDetails,
  closeModal,
}) => {
  let [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (fieldsValue) => {
    let companyId = localStorage.getItem("companyId");
    let addDispatchObject = {
      contractId: contractDetails._id,
      companyId,
      ...fieldsValue,
    };
    await addDispatchHandler(addDispatchObject);
  };

  const onValuesChange = () => {};
  const onFinishFailed = () => {};
  const addDispatchHandler = async (payloadObject) => {
    setIsLoading(true);
    try {
      let response = await addDispatch(payloadObject);
      console.log("response", response);
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
    closeModalHandler();
    getDispatchesOfCurrentContract();
  };

  const closeModalHandler = () => {
    closeModal("dispatchModal");
  };
  return (
    <Modal
      closable={true}
      visible={dispatchModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Add Dispatch"
    >
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col span={24}>
            <Form.Item
              label="Date"
              name="dispatchDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="K.Quantity"
              name="kachiQuantity"
              rules={[
                {
                  required: true,
                  message: "Please Enter Quantity!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Godown"
              name="godownAddress"
              rules={[
                {
                  required: true,
                  message: "Please Enter Godown",
                },
              ]}
            >
              <Select defaultValue="">
                <Option value="">select buyer</Option>
                {contractDetails.buyerCompanyId.GodownAddress.map((godown) => (
                  <Option value={godown}>{godown}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="L Short (in meter)"
              name="lShort"
              rules={[
                {
                  required: true,
                  message: "Please Enter L Short ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="K patch parchi # "
              name="kachiParchiNumber"
              rules={[
                {
                  required: true,
                  message: "Please Enter K patch parchi #  ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24}>
            <Row type="flex" justify="center">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default DispatchModalCompo;
